import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.svg',
    styleUrls: ['./help.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpComponent {}
